var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tm-data-msg',{attrs:{"icon":"rotate_right","spin":"true"}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("Please wait a moment.")])])}
var staticRenderFns = []

export { render, staticRenderFns }